<script setup lang="ts">
import type { Canvass, CanvassHouse } from "@/canvasses/types";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import EditLink from "@/components/links/EditLink.vue";
import ListItem from "@/components/ListItem.vue";
import { useGetContacts } from "@/contacts/contactsCrud";
import ContactStatusDetails from "@/contacts/ContactStatusDetails.vue";
import { UserPlus } from "@iconoir/vue";
import { RouterLink } from "vue-router";

const props = defineProps<{
  canvass: Canvass; // suppress router warnings
  canvassHouse: CanvassHouse;
}>();

const { contacts, getContactsStatus } = useGetContacts(props.canvassHouse.id);
</script>

<template>
  <div class="column container container-md">
    <div class="box column">
      <h2 class="visually-hidden">Kontakte</h2>
      <RouterLink
        class="button"
        role="button"
        :to="{ name: 'canvassFlowNewContact' }"
      >
        <UserPlus />neuen Kontakt
      </RouterLink>
    </div>
    <HandleQueryStatus :query-status="getContactsStatus">
      <ul v-if="contacts && contacts.length > 0" role="list">
        <ListItem v-for="contact in contacts" :key="contact.id">
          <template #header>
            <h3>
              <RouterLink
                :to="{
                  name: 'canvassFlowEditContact',
                  params: { contactId: contact.id },
                }"
              >
                {{ contact.name }}
              </RouterLink>
            </h3>
          </template>
          <ContactStatusDetails :contact="contact" />
          <template #actions>
            <EditLink
              :to="{
                name: 'canvassFlowEditContact',
                params: { contactId: contact.id },
              }"
            />
          </template>
        </ListItem>
      </ul>
      <p v-else class="box">
        Für dieses Haus wurden noch keine Kontakte hinterlegt.
      </p>
    </HandleQueryStatus>
  </div>
</template>
